export const iconFontAwesomeHumanitarianPersonHalfDress = (
	<i className="fa-solid fa-person-half-dress"></i>
);
